<ng-template #financialsContent>
  <div class="relative bg-slate-50 min-h-screen text-slate-800 font-sans p-4 md:p-8 selection:bg-indigo-100 selection:text-indigo-900 w-full">
    
    <div class="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div class="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-blue-400/5 blur-[120px]"></div>
        <div class="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-indigo-400/5 blur-[120px]"></div>
    </div>

    <div class="max-w-7xl mx-auto relative z-10">
      <datalist id="carrier-service-options">
        <option *ngFor="let service of carrierServiceNames" [value]="service"></option>
      </datalist>

      <datalist id="customer-service-options">
        <option *ngFor="let service of customerServiceNames" [value]="service"></option>
      </datalist>

      <section class="overflow-hidden rounded-[24px] border border-slate-900 bg-slate-950 text-white shadow-[0_24px_55px_-32px_rgba(15,23,42,0.72)]" *ngIf="!hideMenu">
        <div class="px-5 py-5 md:px-7 md:py-6">
          <div class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
            <div class="space-y-3">
              <div>
                <div class="text-[11px] font-bold uppercase tracking-[0.22em] text-slate-400">Work Order Details</div>
                <p class="mt-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500">Reference</p>
                <h1 class="text-3xl font-black tracking-tight md:text-4xl">
                  {{ generalInfoForm.get('alternateReference')?.value || generalInfoForm.get('ladingNumber')?.value || 'No Ref' }}
                </h1>
              </div>

              <div class="flex items-center gap-2 text-slate-300">
                <i class="fas fa-link text-slate-500"></i>
                <span class="break-all font-mono text-xs md:text-sm">{{ generalInfoForm.get('ladingUuid')?.value || 'N/A' }}</span>
              </div>

              <p class="text-base font-semibold text-slate-100">
                {{ generalInfoForm.get('customerName')?.value || 'Customer Unassigned' }}<br>
                {{ generalInfoForm.get('customerPo')?.value || 'No Customer PO'}}
              </p>
            </div>

            <div class="flex flex-col gap-3 lg:items-end">
              <span class="inline-flex items-center gap-2 rounded-full border border-slate-800 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-slate-100">
                <span class="h-2 w-2 rounded-full bg-emerald-400" [class.animate-pulse]="generalInfoForm.get('ladingStatus')?.value !== 'Delivered'"></span>
                {{ generalInfoForm.get('ladingStatus')?.value || 'Pending' }}
              </span>

              <div class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
                Last Modified:
                <span class="font-semibold normal-case tracking-normal text-slate-200">
                  {{ generalInfoForm.get('modifiedDate')?.value || generalInfoForm.get('created')?.value || 'N/A' }}
                </span>
              </div>
            </div>
          </div>

          <div class="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
            <div class="rounded-2xl border border-slate-800 bg-white/5 px-4 py-3">
              <p class="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">Appointment</p>
              <p class="mt-1 text-sm font-semibold text-slate-100">{{ generalInfoForm.get('appointmentDate')?.value || 'N/A' }}</p>
              <p class="text-xs text-slate-400">
                {{ generalInfoForm.get('appointmentStart')?.value || 'No time set' }}
                <ng-container *ngIf="generalInfoForm.get('appointmentEnd')?.value"> - {{ generalInfoForm.get('appointmentEnd')?.value }}</ng-container>
              </p>
            </div>

            <div class="rounded-2xl border border-slate-800 bg-white/5 px-4 py-3">
              <p class="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">Pick-up</p>
              <p class="mt-1 text-sm font-semibold text-slate-100">{{ generalInfoForm.get('loadStartDate')?.value || 'N/A' }}</p>
              <p class="text-xs text-slate-400">{{ generalInfoForm.get('loadStartTime')?.value || 'No time set' }}</p>
            </div>

            <div class="rounded-2xl border border-slate-800 bg-white/5 px-4 py-3">
              <p class="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">Delivery</p>
              <p class="mt-1 text-sm font-semibold text-slate-100">{{ generalInfoForm.get('loadEndDate')?.value || 'N/A' }}</p>
              <p class="text-xs text-slate-400">{{ generalInfoForm.get('loadEndTime')?.value || 'No time set' }}</p>
            </div>

            <div class="rounded-2xl border border-slate-800 bg-white/5 px-4 py-3">
              <p class="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">Load Metrics</p>
              <p class="mt-1 text-sm font-semibold text-slate-100">
                {{ generalInfoForm.get('loadWeightActual')?.value || generalInfoForm.get('loadWeight')?.value || '0' }}
                <span class="uppercase text-slate-300">{{ generalInfoForm.get('loadWeightUnit')?.value || 'lb' }}</span>
              </p>
              <p class="text-xs text-slate-400">
                Pcs: {{ generalInfoForm.get('loadPieces')?.value || '0' }}
                &bull;
                Pal: {{ generalInfoForm.get('loadPallets')?.value || '0' }}
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <div *ngIf="loading" class="mb-6 bg-white/80 backdrop-blur-sm p-4 rounded-2xl shadow-sm border border-slate-200 flex items-center justify-center gap-3 text-indigo-600 font-bold">
        <i class="fas fa-circle-notch fa-spin"></i> Loading Financials...
      </div>

      <div *ngIf="!loading && errorMessage" class="mb-6 bg-rose-50 border border-rose-200 text-rose-800 p-4 rounded-xl shadow-sm flex items-start gap-3">
        <i class="fas fa-exclamation-triangle text-rose-500 mt-1"></i>
        <div>
            <p class="font-bold">Unable to load financials.</p>
            <p class="text-sm mt-1 opacity-90">{{ errorMessage }}</p>
        </div>
      </div>

      <ng-container *ngIf="!loading && !errorMessage">
        <ng-template #partiesSection>
          <section class="mb-8" *ngIf="partySummaries.length">
            <div class="mb-5 flex items-center gap-3">
              <span class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
                <i class="fas fa-users"></i>
              </span>
              <h3 class="text-2xl font-black tracking-tight text-slate-800">Parties Involved</h3>
            </div>

            <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
              <article *ngFor="let party of partySummaries" class="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                <div class="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-blue-400 to-indigo-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>

                <div class="mb-4 flex items-start justify-between gap-3">
                  <span class="rounded-md bg-slate-100 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.18em] text-slate-500">
                    {{ party.label }}
                  </span>
                  <i class="fas text-slate-300 transition-colors duration-300 group-hover:text-indigo-400" [ngClass]="party.iconClass"></i>
                </div>

                <div class="space-y-3">
                  <div>
                    <p class="truncate text-sm font-extrabold text-slate-800" [title]="party.name">{{ party.name }}</p>
                    <p class="truncate text-[11px] text-slate-500" [title]="party.email">{{ party.email }}</p>
                  </div>

                  <div class="min-h-[60px] rounded-xl border border-slate-100 bg-slate-50/70 p-3 text-xs text-slate-600">
                    <p class="truncate" [title]="party.street">{{ party.street }}</p>
                    <p class="truncate" [title]="party.localityRegionPostal">{{ party.localityRegionPostal }}</p>
                  </div>

                  <div class="flex items-center gap-2 border-t border-slate-100 pt-2 text-xs font-mono text-slate-600">
                    <i class="fas fa-phone text-slate-400"></i>
                    <span>{{ party.phone }}</span>
                  </div>
                </div>
              </article>
            </div>
          </section>
        </ng-template>
        
        <div class="mb-8 flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
          <div>
              <div class="flex items-center gap-3 mb-2">
                  <div class="p-2 bg-indigo-100 text-indigo-600 rounded-lg shadow-sm border border-indigo-200">
                    <i class="fas fa-file-invoice-dollar text-xl"></i>
                  </div>
                  <h1 class="text-3xl md:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-700 to-indigo-700 tracking-tight">
                    Financial <span class="font-light">Ledger</span>
                  </h1>
              </div>
              <p class="text-slate-500 font-medium ml-12" *ngIf="activeLadingUuid">
                Lading: <span class="font-mono text-sm">{{ activeLadingUuid }}</span>
              </p>
          </div>

          <div class="flex flex-wrap items-center gap-3">
            <ng-container *ngIf="settlement as s">
              <div class="flex gap-2 mr-4">
                <span class="px-3 py-1 rounded-lg text-[10px] font-bold uppercase tracking-widest border flex items-center gap-1.5" [ngClass]="sourceClass(s.settlement_source)">
                  {{ sourceLabel(s.settlement_source) }}
                </span>
                <span class="px-3 py-1 rounded-lg text-[10px] font-bold uppercase tracking-widest border flex items-center gap-1.5" [ngClass]="statusClass(s.rating_status)">
                  {{ ratingStatusLabel(s.rating_status) }}
                </span>
              </div>
              <p class="text-[10px] text-slate-400 uppercase tracking-widest font-semibold mr-4 hidden lg:block" *ngIf="s.updated_at">
                Updated: <span class="text-slate-600">{{ formatTimestamp(s.updated_at) }}</span>
              </p>
            </ng-container>

            <button *ngIf="!hasSettlement" (click)="runAutorate()" [disabled]="autorating || !activeLadingUuid" class="bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-400 hover:to-teal-400 text-slate-900 font-extrabold px-5 py-2.5 rounded-xl shadow-[0_0_15px_rgba(16,185,129,0.3)] transition-all flex items-center gap-2 text-xs uppercase tracking-widest hover:scale-105 active:scale-95 disabled:opacity-50">
              <i class="fas" [ngClass]="autorating ? 'fa-spinner fa-spin' : 'fa-bolt'"></i>
              {{ autorating ? 'Autorating...' : 'Autorate' }}
            </button>

            <button *ngIf="hasSettlement" (click)="isEditing.next(!isEditing.value)" class="bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 font-bold px-5 py-2.5 rounded-xl transition-all shadow-sm flex items-center gap-2 text-sm">
              <i class="fas" [ngClass]="isEditing.value ? 'fa-eye text-indigo-500' : 'fa-edit text-slate-400'"></i>
              {{ isEditing.value ? 'View Mode' : 'Edit Mode' }}
            </button>

            <button *ngIf="hasSettlement" (click)="saveFinancials()" [disabled]="!canSave" class="bg-slate-900 hover:bg-slate-800 text-white font-bold px-5 py-2.5 rounded-xl transition-all shadow-md flex items-center gap-2 text-sm disabled:opacity-50 disabled:cursor-not-allowed">
              <i class="fas" [ngClass]="saving ? 'fa-spinner fa-spin' : 'fa-save'"></i>
              {{ saving ? 'Saving...' : 'Save Financials' }}
            </button>
            <button *ngIf="hasSettlement && !chargesApproved" (click)="approveCustomerCharges()" class="bg-slate-900 hover:bg-slate-800 text-white font-bold px-5 py-2.5 rounded-xl transition-all shadow-md flex items-center gap-2 text-sm">
              Approve Customer Charges
            </button>
            <button *ngIf="hasSettlement && chargesApproved" class="bg-slate-900 hover:bg-slate-800 text-white font-bold px-5 py-2.5 rounded-xl transition-all shadow-md flex items-center gap-2 text-sm">Create Invoice</button>
            <button *ngIf="hasSettlement" (click)="approveCarrierCosts()" class="bg-slate-900 hover:bg-slate-800 text-white font-bold px-5 py-2.5 rounded-xl transition-all shadow-md flex items-center gap-2 text-sm">
              Approve Carrier Costs
            </button>
            <button class="bg-slate-900 hover:bg-slate-800 text-white font-bold px-5 py-2.5 rounded-xl transition-all shadow-md flex items-center gap-2 text-sm"  (click)="sendCarrierConfirmationEmail(false)">Send Carrier Confirmation Email</button>
            <button class="bg-slate-900 hover:bg-slate-800 text-white font-bold px-5 py-2.5 rounded-xl transition-all shadow-md flex items-center gap-2 text-sm disabled:opacity-50 disabled:cursor-not-allowed" [disabled]="carrierConfirmationPdfPreviewLoading" (click)="previewCarrierConfirmationPdf()">
              <i class="fas" [ngClass]="carrierConfirmationPdfPreviewLoading ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
              {{ carrierConfirmationPdfPreviewLoading ? 'Preparing PDF...' : 'Preview Carrier Confirmation PDF' }}
            </button>
          </div>
        </div>

        <div *ngIf="!hasSettlement" class="text-center p-16 text-slate-500 bg-white/80 backdrop-blur-sm rounded-2xl shadow-sm border border-slate-200 mt-8">
            <div class="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4 text-slate-300 text-3xl">
              <i class="fas fa-file-invoice"></i>
            </div>
            <p class="font-extrabold text-xl text-slate-700">No Settlement Exists</p>
            <p class="text-sm mt-2 opacity-80">Run the autorater to create carrier costs and customer charges for this lading.</p>
        </div>

        <ng-container *ngIf="hasSettlement && settlement as currentSettlement">
          
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div class="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm relative overflow-hidden group">
              <div class="absolute top-0 left-0 w-full h-1 bg-rose-400 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <p class="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Carrier Total</p>
              <p class="text-3xl font-black text-slate-800">${{ formatMoney(carrierTotals.totalCents) }}</p>
            </div>

            <div class="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm relative overflow-hidden group">
              <div class="absolute top-0 left-0 w-full h-1 bg-blue-400 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <p class="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Customer Total</p>
              <p class="text-3xl font-black text-slate-800">${{ formatMoney(customerTotals.totalCents) }}</p>
            </div>

            <div class="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm relative overflow-hidden group" [class.bg-rose-50]="(draftMarginCents || 0) < 0">
              <div class="absolute top-0 left-0 w-full h-1 bg-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <p class="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Projected Margin</p>
              <p class="text-3xl font-black" [class.text-rose-600]="(draftMarginCents || 0) < 0" [class.text-slate-800]="(draftMarginCents || 0) >= 0">
                ${{ formatMoney(draftMarginCents) }}
              </p>
            </div>

            <div class="bg-gradient-to-br from-emerald-500 to-teal-600 border border-emerald-600 rounded-2xl p-5 relative overflow-hidden shadow-md text-white flex flex-col justify-center">
              <div class="absolute -right-6 -bottom-6 opacity-20 text-7xl">
                <i class="fas fa-chart-pie"></i>
              </div>
              <div class="relative z-10">
                <p class="text-xs font-bold text-emerald-100 uppercase tracking-widest mb-1">Margin %</p>
                <p class="text-4xl font-black mb-1">{{ formatPercent(draftMarginPercent) }}</p>
              </div>
            </div>
          </div>

          <ng-container *ngTemplateOutlet="partiesSection"></ng-container>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" *ngIf="currentSettlement.blocking_errors?.length || currentSettlement.warnings?.length">
            <div class="bg-rose-50 border-l-4 border-rose-500 p-5 rounded-r-2xl shadow-sm" *ngIf="currentSettlement.blocking_errors?.length">
              <p class="text-xs font-bold text-rose-800 uppercase tracking-widest mb-3 flex items-center gap-2">
                  <i class="fas fa-ban"></i> Blocking Errors
              </p>
              <ul class="list-disc pl-5 text-sm text-rose-700 space-y-1 font-medium">
                  <li *ngFor="let item of currentSettlement.blocking_errors">{{ item }}</li>
              </ul>
            </div>

            <div class="bg-amber-50 border-l-4 border-amber-400 p-5 rounded-r-2xl shadow-sm" *ngIf="currentSettlement.warnings?.length">
              <p class="text-xs font-bold text-amber-800 uppercase tracking-widest mb-3 flex items-center gap-2">
                  <i class="fas fa-exclamation-triangle"></i> Warnings
              </p>
              <ul class="list-disc pl-5 text-sm text-amber-700 space-y-1 font-medium">
                  <li *ngFor="let item of currentSettlement.warnings">{{ item }}</li>
              </ul>
            </div>
          </div>

          <div class="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-24">
            
            <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
              <div class="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                <div>
                  <h3 class="text-lg font-extrabold text-slate-800 flex items-center gap-2">
                    <i class="fas fa-truck text-rose-400"></i> Carrier Cost
                  </h3>
                  <p class="text-xs text-slate-500 mt-1 font-mono" *ngIf="carrierSide.contactUuid">Contact: {{ carrierSide.contactUuid }}</p>
                </div>
                
                <div class="flex items-center gap-3">
                  <div class="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border border-slate-200">
                    <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Tax %</span>
                    <input *ngIf="isEditing.value" type="number" step="0.01" class="w-16 text-sm font-mono font-bold text-slate-700 outline-none text-right" [ngModel]="displayTaxRatePercent(carrierSide)" (ngModelChange)="updateTaxRate(carrierSide, $event)" [ngModelOptions]="{ standalone: true }">
                    <span *ngIf="!isEditing.value" class="w-16 text-sm font-mono font-bold text-slate-700 text-right">{{ displayTaxRatePercent(carrierSide) || '0.00' }}</span>
                  </div>
                  <button *ngIf="isEditing.value" type="button" class="bg-slate-800 text-white hover:bg-slate-900 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors disabled:opacity-50" [disabled]="!carrierSide.headerUuid" (click)="addLineItem(carrierSide)">
                    <i class="fas fa-plus"></i> Add
                  </button>
                </div>
              </div>

              <div class="grid grid-cols-3 gap-4 p-4 border-b border-slate-100 bg-slate-50/30">
                <div>
                  <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Subtotal</span>
                  <span class="font-mono font-bold text-slate-700 text-lg">${{ formatMoney(carrierTotals.subtotalCents) }}</span>
                </div>
                <div>
                  <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Tax</span>
                  <span class="font-mono font-bold text-slate-700 text-lg">${{ formatMoney(carrierTotals.taxTotalCents) }}</span>
                </div>
                <div>
                  <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Total</span>
                  <span class="font-mono font-extrabold text-slate-900 text-lg">${{ formatMoney(carrierTotals.totalCents) }}</span>
                </div>
              </div>

              <div class="overflow-x-auto flex-grow custom-scrollbar">
                <table class="w-full text-sm text-left" *ngIf="sideHasRows(carrierSide); else emptyCarrierState">
                  <thead class="bg-white text-slate-600 text-[12px] tracking-widest uppercase border-b border-slate-100">
                    <tr>
                      <th class="px-4 py-3 font-bold whitespace-nowrap">Service Details</th>
                      <th class="px-4 py-3 font-bold text-right whitespace-nowrap">Rate / Unit</th>
                      <th class="px-4 py-3 font-bold text-center whitespace-nowrap">Quantity</th>
                      <th class="px-4 py-3 font-bold text-right whitespace-nowrap">Net Amount</th>
                      <th class="px-3 py-3" *ngIf="isEditing.value"></th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-50">
                    <tr *ngFor="let item of carrierSide.lineItems; trackBy: trackLineItem" class="hover:bg-slate-50/80 transition-colors">
                      
                      <td class="px-4 py-3" *ngIf="!isEditing.value">
                        <div class="font-extrabold text-slate-800">{{ item.serviceName || '-' }}</div>
                        <div class="text-[12px] text-slate-500 mt-0.5 flex gap-2">
                          <span *ngIf="item.serviceType">{{ item.serviceType }}</span>
                          <span *ngIf="item.note" class="italic text-slate-400 ml-2 border-l border-slate-300 pl-2">{{ item.note }}</span>
                        </div>
                      </td>

                      <td class="px-4 py-3 min-w-[200px]" *ngIf="isEditing.value">
                        <input
                          #carrierServiceInput
                          type="text"
                          list="carrier-service-options"
                          placeholder="Service Name"
                          class="w-full border border-slate-300 rounded-md px-2 py-1.5 text-sm mb-1 focus:ring-1 focus:ring-indigo-500 outline-none font-bold text-slate-800"
                          [ngModel]="item.serviceName"
                          (ngModelChange)="updateServiceName(item, $event)"
                          (blur)="applyDefaultRateForService(carrierSide.kind, item, carrierServiceInput.value)"
                          [ngModelOptions]="{ standalone: true }">
                        <div class="mb-1 text-[10px] text-slate-400">
                          Pick a saved service or type any custom service. Saved services apply default rates.
                        </div>
                        <div *ngIf="item.contactServiceRateUuid" class="mb-1 text-[10px] font-semibold text-emerald-600">
                          Default rate linked
                        </div>
                        <div class="flex gap-2">
                          <input type="text" placeholder="Type" class="w-1/2 border border-slate-300 rounded-md px-2 py-1 text-s text-slate-600 outline-none" [ngModel]="item.serviceType" (ngModelChange)="updateLineText(item, 'serviceType', $event)" [ngModelOptions]="{ standalone: true }">
                          <input type="text" placeholder="Note" class="w-1/2 border border-slate-300 rounded-md px-2 py-1 text-s text-slate-600 outline-none" [ngModel]="item.note" (ngModelChange)="updateLineText(item, 'note', $event)" [ngModelOptions]="{ standalone: true }">
                        </div>
                      </td>

                      <td class="px-4 py-3 text-right font-mono text-sm text-slate-600" *ngIf="!isEditing">
                        <span class="font-bold text-slate-800">${{ item.rateDollars !== null ? item.rateDollars : '0.00' }}</span> <span class="text-[12px] uppercase text-slate-400">/ {{ item.rateUnit || 'FLAT' }}</span>
                      </td>

                      <td class="px-4 py-3 text-right min-w-[140px]" *ngIf="isEditing.value">
                        <div class="flex items-center justify-end gap-1">
                          <span class="text-slate-400">$</span>
                          <input type="number" step="0.01" class="w-16 border border-slate-300 rounded-md px-2 py-1.5 text-sm font-mono text-right outline-none" [ngModel]="item.rateDollars" (ngModelChange)="updateLineNumber(item, 'rateDollars', $event)" [ngModelOptions]="{ standalone: true }">
                          <span class="text-slate-400">/</span>
                          <input type="text" class="w-14 border border-slate-300 rounded-md px-2 py-1.5 text-xs uppercase text-center outline-none" [ngModel]="item.rateUnit" (ngModelChange)="updateLineText(item, 'rateUnit', $event)" [ngModelOptions]="{ standalone: true }">
                        </div>
                      </td>

                      <td class="px-4 py-3 text-center font-mono text-sm font-bold text-slate-500" *ngIf="!isEditing.value" [attr.title]="formatLineQuantityTitle(item)">
                        {{ formatLineQuantity(item) }}
                      </td>

                      <td class="px-4 py-3 text-center" *ngIf="isEditing.value">
                        <input type="number" step="0.01" class="w-14 border border-slate-300 rounded-md px-2 py-1.5 text-sm font-mono text-center outline-none mx-auto" [ngModel]="item.multiplier" (ngModelChange)="updateLineNumber(item, 'multiplier', $event)" [ngModelOptions]="{ standalone: true }">
                      </td>

                      <td class="px-4 py-3 text-right font-mono font-bold text-slate-900 bg-slate-50/50 text-lg">
                        ${{ formatMoney(item.netAmountCents) }}
                      </td>
                      
                      <td class="px-3 py-3 text-center" *ngIf="isEditing.value">
                        <button type="button" class="w-7 h-7 rounded bg-rose-50 text-rose-500 hover:bg-rose-100 hover:text-rose-700 transition-colors flex items-center justify-center" (click)="removeLineItem(carrierSide, item)">
                          <i class="fas fa-trash-alt text-xs"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ng-template #emptyCarrierState>
                  <div class="p-12 text-center text-slate-400 text-sm italic flex flex-col items-center">
                    <i class="fas fa-folder-open text-2xl mb-2 opacity-30"></i>
                    No carrier line items.
                  </div>
                </ng-template>
              </div>
            </div>

            <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
              <div class="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-col sm:flex-row justify-between sm:items-center gap-4">
                <div>
                  <h3 class="text-lg font-extrabold text-slate-800 flex items-center gap-2">
                    <i class="fas fa-building text-blue-500"></i> Customer Charge
                  </h3>
                  <p class="text-xs text-slate-500 mt-1 font-mono" *ngIf="customerSide.contactUuid">Contact: {{ customerSide.contactUuid }}</p>
                </div>
                
                <div class="flex items-center gap-3">
                  <div class="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border border-slate-200">
                    <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Tax %</span>
                    <input *ngIf="isEditing.value" type="number" step="0.01" class="w-16 text-sm font-mono font-bold text-slate-700 outline-none text-right" [ngModel]="displayTaxRatePercent(customerSide)" (ngModelChange)="updateTaxRate(customerSide, $event)" [ngModelOptions]="{ standalone: true }">
                    <span *ngIf="!isEditing.value" class="w-16 text-sm font-mono font-bold text-slate-700 text-right">{{ displayTaxRatePercent(customerSide) || '0.00' }}</span>
                  </div>
                  <button *ngIf="isEditing.value" type="button" class="bg-slate-800 text-white hover:bg-slate-900 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors disabled:opacity-50" [disabled]="!customerSide.headerUuid" (click)="addLineItem(customerSide)">
                    <i class="fas fa-plus"></i> Add
                  </button>
                </div>
              </div>

              <div class="grid grid-cols-3 gap-4 p-4 border-b border-slate-100 bg-slate-50/30">
                <div>
                  <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Subtotal</span>
                  <span class="font-mono font-bold text-slate-700 text-lg">${{ formatMoney(customerTotals.subtotalCents) }}</span>
                </div>
                <div>
                  <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Tax</span>
                  <span class="font-mono font-bold text-slate-700 text-lg">${{ formatMoney(customerTotals.taxTotalCents) }}</span>
                </div>
                <div>
                  <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Total</span>
                  <span class="font-mono font-extrabold text-slate-900 text-lg">${{ formatMoney(customerTotals.totalCents) }}</span>
                </div>
              </div>

              <div class="overflow-x-auto flex-grow custom-scrollbar">
                <table class="w-full text-sm text-left" *ngIf="sideHasRows(customerSide); else emptyCustomerState">
                  <thead class="bg-white text-slate-600 text-[12px] tracking-widest uppercase border-b border-slate-100">
                    <tr>
                      <th class="px-4 py-3 font-bold whitespace-nowrap">Service Details</th>
                      <th class="px-4 py-3 font-bold text-right whitespace-nowrap">Rate / Unit</th>
                      <th class="px-4 py-3 font-bold text-center whitespace-nowrap">Quantity</th>
                      <th class="px-4 py-3 font-bold text-right whitespace-nowrap">Net Amount</th>
                      <th class="px-3 py-3" *ngIf="isEditing.value"></th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-50">
                    <tr *ngFor="let item of customerSide.lineItems; trackBy: trackLineItem" class="hover:bg-slate-50/80 transition-colors">
                      
                      <td class="px-4 py-3" *ngIf="!isEditing.value">
                        <div class="font-extrabold text-slate-800">{{ item.serviceName || '-' }}</div>
                        <div class="text-[12px] text-slate-500 mt-0.5 flex gap-2">
                          <span *ngIf="item.serviceType">{{ item.serviceType }}</span>
                          <span *ngIf="item.note" class="italic text-slate-400 ml-2 border-l border-slate-300 pl-2">{{ item.note }}</span>
                        </div>
                      </td>

                      <td class="px-4 py-3 min-w-[200px]" *ngIf="isEditing.value">
                        <input
                          #customerServiceInput
                          type="text"
                          list="customer-service-options"
                          placeholder="Service Name"
                          class="w-full border border-slate-300 rounded-md px-2 py-1.5 text-sm mb-1 focus:ring-1 focus:ring-indigo-500 outline-none font-bold text-slate-800"
                          [ngModel]="item.serviceName"
                          (ngModelChange)="updateServiceName(item, $event)"
                          (blur)="applyDefaultRateForService(customerSide.kind, item, customerServiceInput.value)"
                          [ngModelOptions]="{ standalone: true }">
                        <div class="mb-1 text-[10px] text-slate-400">
                          Pick a saved service or type any custom service. Saved services apply default rates.
                        </div>
                        <div *ngIf="item.contactServiceRateUuid" class="mb-1 text-[10px] font-semibold text-emerald-600">
                          Default rate linked
                        </div>
                        <div class="flex gap-2">
                          <input type="text" placeholder="Type" class="w-1/2 border border-slate-300 rounded-md px-2 py-1 text-xs text-slate-600 outline-none" [ngModel]="item.serviceType" (ngModelChange)="updateLineText(item, 'serviceType', $event)" [ngModelOptions]="{ standalone: true }">
                          <input type="text" placeholder="Note" class="w-1/2 border border-slate-300 rounded-md px-2 py-1 text-xs text-slate-600 outline-none" [ngModel]="item.note" (ngModelChange)="updateLineText(item, 'note', $event)" [ngModelOptions]="{ standalone: true }">
                        </div>
                      </td>

                      <td class="px-4 py-3 text-right font-mono text-sm text-slate-600" *ngIf="!isEditing.value">
                        <span class="font-bold text-slate-800">${{ item.rateDollars !== null ? item.rateDollars : '0.00' }}</span> <span class="text-[12px] uppercase text-slate-400">/ {{ item.rateUnit || 'FLAT' }}</span>
                      </td>

                      <td class="px-4 py-3 text-right min-w-[140px]" *ngIf="isEditing.value">
                        <div class="flex items-center justify-end gap-1">
                          <span class="text-slate-400">$</span>
                          <input type="number" step="0.01" class="w-16 border border-slate-300 rounded-md px-2 py-1.5 text-sm font-mono text-right outline-none" [ngModel]="item.rateDollars" (ngModelChange)="updateLineNumber(item, 'rateDollars', $event)" [ngModelOptions]="{ standalone: true }">
                          <span class="text-slate-400">/</span>
                          <input type="text" class="w-14 border border-slate-300 rounded-md px-2 py-1.5 text-xs uppercase text-center outline-none" [ngModel]="item.rateUnit" (ngModelChange)="updateLineText(item, 'rateUnit', $event)" [ngModelOptions]="{ standalone: true }">
                        </div>
                      </td>

                      <td class="px-4 py-3 text-center font-mono text-sm font-bold text-slate-500" *ngIf="!isEditing.value" [attr.title]="formatLineQuantityTitle(item)">
                        {{ formatLineQuantity(item) }}
                      </td>

                      <td class="px-4 py-3 text-center" *ngIf="isEditing.value">
                        <input type="number" step="0.01" class="w-14 border border-slate-300 rounded-md px-2 py-1.5 text-sm font-mono text-center outline-none mx-auto" [ngModel]="item.multiplier" (ngModelChange)="updateLineNumber(item, 'multiplier', $event)" [ngModelOptions]="{ standalone: true }">
                      </td>

                      <td class="px-4 py-3 text-right font-mono font-bold text-slate-900 bg-slate-50/50 text-lg">
                        ${{ formatMoney(item.netAmountCents) }}
                      </td>
                      
                      <td class="px-3 py-3 text-center" *ngIf="isEditing.value">
                        <button type="button" class="w-7 h-7 rounded bg-rose-50 text-rose-500 hover:bg-rose-100 hover:text-rose-700 transition-colors flex items-center justify-center" (click)="removeLineItem(customerSide, item)">
                          <i class="fas fa-trash-alt text-xs"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ng-template #emptyCustomerState>
                  <div class="p-12 text-center text-slate-400 text-sm italic flex flex-col items-center">
                    <i class="fas fa-folder-open text-2xl mb-2 opacity-30"></i>
                    No customer line items.
                  </div>
                </ng-template>
              </div>
            </div>

          </div>
        </ng-container>

      </ng-container>
    </div>

    <div class="fixed bottom-8 right-8 z-50 animate-[bounce_1s_ease-in-out_infinite]" style="animation-iteration-count: 3;" *ngIf="isEditing.value && hasUnsavedChanges">
       <button (click)="saveFinancials()" [disabled]="saving" class="bg-slate-900 text-white font-black px-8 py-4 rounded-2xl shadow-2xl hover:scale-105 transition-all flex items-center gap-3 disabled:opacity-50 disabled:scale-100">
         <i class="fas" [ngClass]="saving ? 'fa-spinner fa-spin text-slate-400' : 'fa-save text-emerald-400'"></i>
         {{ saving ? 'SAVING...' : 'SAVE CHANGES' }}
       </button>
    </div>

  </div>
</ng-template>

<ng-template #carrierConfirmationPdfPreviewDialog>
  <div class="grid h-[86vh] max-h-[94vh] grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden bg-slate-50 text-slate-900">
    <header class="flex items-center justify-between gap-4 border-b border-slate-200 bg-white px-5 py-3">
      <div>
        <p class="m-0 mb-1 text-[11px] font-extrabold uppercase leading-none tracking-[0.16em] text-slate-500">Carrier Confirmation</p>
        <h2 class="m-0 text-lg font-extrabold leading-tight text-slate-900">Review PDF</h2>
      </div>
      <button
        type="button"
        class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-300 bg-white text-slate-600 transition hover:border-slate-400 hover:bg-slate-100 hover:text-slate-900"
        aria-label="Close PDF preview"
        (click)="closeCarrierConfirmationPdfPreview()">
        <i class="fas fa-times"></i>
      </button>
    </header>

    <mat-dialog-content class="!m-0 !max-h-none !p-0 overflow-hidden bg-slate-900">
      <div class="h-full bg-slate-900 p-2">
        <iframe
          *ngIf="carrierConfirmationPdfPreviewUrl"
          class="block h-full min-h-0 w-full rounded-lg border-0 bg-neutral-800"
          title="Carrier confirmation PDF preview"
          [src]="carrierConfirmationPdfPreviewUrl">
        </iframe>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="!m-0 flex !min-h-0 items-center justify-end gap-3 border-t border-slate-200 bg-white !px-5 !py-2">
      <button class="inline-flex min-h-9 items-center justify-center rounded-lg border border-slate-300 bg-white px-4 text-sm font-extrabold text-slate-700 transition hover:border-slate-400 hover:bg-slate-50" type="button" (click)="closeCarrierConfirmationPdfPreview()">Cancel</button>
      <button
        class="inline-flex min-h-9 items-center justify-center gap-2 rounded-lg border border-blue-700 bg-blue-600 px-4 text-sm font-extrabold text-white shadow-[0_8px_18px_rgba(37,99,235,0.22)] transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-55"
        type="button"
        [disabled]="carrierConfirmationPdfSending || !carrierConfirmationPdfPreviewUrl"
        (click)="sendCarrierConfirmationEmail(true)">
        <i class="fas" [ngClass]="carrierConfirmationPdfSending ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
        {{ carrierConfirmationPdfSending ? 'Sending...' : 'Send PDF Email' }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-container *ngIf="!hideMenu; else withoutMenu">
  <app-menu>
    <ng-container *ngTemplateOutlet="financialsContent"></ng-container>
  </app-menu>
</ng-container>

<ng-template #withoutMenu>
  <ng-container *ngTemplateOutlet="financialsContent"></ng-container>
</ng-template>

<ng-template #carrierEmailAddressDialog>
  <h2 mat-dialog-title>Carrier Email Address Not Found</h2>

  <mat-dialog-content>
    <div class="mat-dialog-content-wrapper"> 
        <div>Please enter the carrier's email address to send the confirmation to.</div>
        
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Carrier Email (Required)</mat-label>
            <input matInput 
                  type="email" 
                  placeholder="name@carrier.com" 
                  [formControl]="carrierEmailAddressControl" 
                  required>
            <mat-error *ngIf="carrierEmailAddressControl.errors?.['required'] && carrierEmailAddressControl.touched">
                Email is required.
            </mat-error>
            <mat-error *ngIf="carrierEmailAddressControl.errors?.['email'] && carrierEmailAddressControl.touched">
                Please enter a valid email address.
            </mat-error>
        </mat-form-field>
        
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Additional CC Emails (Comma Separated)</mat-label>
            <input matInput 
                  type="text" 
                  placeholder="colleague@email.com, partner@email.com" 
                  [formControl]="optionalCCControl">
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Additional BCC Emails (Comma Separated)</mat-label>
            <input matInput 
                  type="text" 
                  placeholder="boss@email.com" 
                  [formControl]="optionalBCCControl">
        </mat-form-field>
        
        <mat-checkbox 
            [(ngModel)]="sendCopyToggle">
            Send a copy to me
        </mat-checkbox>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="closeCarrierEmailAddressDialog()">Cancel</button>
    <button mat-flat-button 
            color="primary" 
            [disabled]="carrierEmailAddressControl.invalid" 
            (click)="sendCarrierConfirmationEmailWithAddressInput()">Submit</button>
  </mat-dialog-actions>
</ng-template>
